export default "__VITE_ASSET__CPoAZGs4__"